import { formatFilterButtonDate } from '../../../../utils/date'
import { useTimelineLabels } from '../../TimelineSelect/useTimelineSelectOptions'
import { TimelineFilterValue } from '../types'

export const useTimelineFilterLabel = (
    timelineFilterValue: TimelineFilterValue
) => {
    const labelsMap = useTimelineLabels()

    if (timelineFilterValue.type === 'is') {
        return labelsMap[timelineFilterValue.value]
    }

    if (timelineFilterValue.type === 'isBefore') {
        return `Before ${formatFilterButtonDate(timelineFilterValue.value.endDate)}`
    }

    if (timelineFilterValue.type === 'isAfter') {
        return `After ${formatFilterButtonDate(timelineFilterValue.value.startDate)}`
    }

    return `${formatFilterButtonDate(timelineFilterValue.value.startDate)} - ${formatFilterButtonDate(timelineFilterValue.value.endDate)}`
}
